<template>
  <v-col
    class="px-0"
    :cols="block.cols"
    :xs="block.colsxs"
    :sm="block.colssm"
    :md="block.colsmd"
    :lg="block.colslg"
    :xl="block.colsxl"
    :offset="block.offset"
  >
    <v-row style="border: 2px solid var(--v-primary-base)" class="pl-6">
      <v-col cols="12" class="font-weight-medium pl-14 pb-0 primary--text" style="font-size: 18px !important">
        {{ block.inputLabel }}
      </v-col>

      <v-col cols="2" class="pl-14 pb-6 pt-0">
        <v-text-field
          v-model="counter"
          label="Anzahl"
          type="number"
          hide-details="auto"
          min="1"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
   name: 'DCUsers',
   model: {
      prop: 'form',
      event: 'update:form',
   },

   props: {
      block: {
         type: Object,
         required: true,
      },
      form: {
         type: String,
         default: () => '',
      },
   },
}
</script>
<style>
/* .v-text-field--outlined .v-label {
      font-size: 20px;
   }
   .v-text-field--outlined.v-input--dense .v-label--active {
      transform: translateY(-18px) scale(0.75);
   }
   .v-text-field--outlined input {
      outline: none;
   } */
</style>
